module.exports = __webpack_public_path__ + "media/site/images/products/ekanban-screen2@2x-038a41a88270fed68a96c705fe805a81.png";